/**
 * If this file is updated: also update layout/default.njk
 */
import ES6Promise from 'es6-promise';
ES6Promise.polyfill();
// From npm module
import 'core-js/fn/dom-collections/iterator';
import 'core-js/fn/array/from';
import 'core-js/fn/array/find';
import 'core-js/fn/object/assign';
import 'core-js/es6/map';
import 'core-js/es6/promise';
import 'core-js/es6/weak-map';
import 'core-js/es6/weak-set';

import 'mdn-polyfills/Node.prototype.prepend';
import 'mdn-polyfills/Node.prototype.append';
import 'mdn-polyfills/Node.prototype.remove';
import 'babel-polyfill';
import smoothScroll from 'smoothscroll-polyfill';

import ElementClosest from 'element-closest';
import 'polyfills/ieCustomProperties';
import 'polyfills/ieCustomEvents';
import 'url-search-params-polyfill';

smoothScroll.polyfill();
ElementClosest(window);

import 'isomorphic-fetch';
import 'classlist.js';
import svg4everybody from 'svg4everybody';

svg4everybody({
    attributeName: 'data-href',
    polyfill: true
});


// From vendor folder
import 'vendor/epiloque/element-dataset';
require('intersection-observer');
require('focus-visible');
